module.exports = __webpack_public_path__ + "static/Untitled-1-02-dccc372ef3a1d3e6b0582220151e5a5a.jpg";